import React, { Component } from "react";
import axios from "axios";
import apiUrl from "../../../shared/config";
import makeAnimated from "react-select/animated";
import Select, {createFilter} from "react-select";

class PatternConditionInput extends Component {
    state = {
        pattern_conditions: [],
        isLoading: true,
        isError: false
    };

    componentDidMount() {
        if (this.props.pattern_conditions) {
            this.setState({ pattern_conditions: this.props.pattern_conditions, isLoading: false });
        } else {
            this.fetchPatternConditions();
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.pattern_conditions !== this.state.pattern_conditions) {
            this.setState({ pattern_conditions: this.props.pattern_conditions, isLoading: false });
        }
    }

    fetchPatternConditions = () => {
        axios.get(apiUrl + 'PatternConditions/getPatternConditions')
            .then(response => {
                this.setState({ pattern_conditions: response.data, isLoading: false });
            })
            .catch(error => {
                console.error('Error fetching conditions:', error);
                this.setState({ isError: true, isLoading: false });
            });
    };

    render() {
        const { pattern_conditions, isLoading, isError } = this.state;
        const { pattern_condition_filter, patternConditionsUpdate, updatePage, closePatternDetails } = this.props;

        // Handle errors
        if (isError) {
            return (
                <Select
                    isMulti
                    isSearchable
                    options={[]}
                    placeholder="Error loading conditions. Please try again later."
                />
            );
        }

        // Handle loading state
        if (isLoading) {
            return (
                <Select
                    isMulti
                    isSearchable
                    options={[]}
                    placeholder="Loading conditions..."
                />
            );
        }

        const options =
             pattern_conditions.map(pattern_condition => ({
                value: pattern_condition.condition_id,
                label: pattern_condition.condition_title,
                description: pattern_condition.condition_description,
                color: '#9999FF'
            }));
        const animatedComponents = makeAnimated();

        const defaultOptions = pattern_condition_filter.map(pattern_condition_id => {
            return options.find(option => option.value === pattern_condition_id) || { value: 0, label: "Invalid pattern condition id", color: '#9999FF' };
        });

        const condition_description_wrapper = (description = '""') =>  ({
           ':after': {
                content: description ? ('" - ' + description + '"') : '',
                fontSize: 14,
           },
        });

        return (
            <Select
                isMulti
                isSearchable
                styles={{
                    option: (styles, { data }) => {
                        return {
                            ...styles,
                            ...condition_description_wrapper(data.description)
                        };
                    },
                }}
                filterOption={createFilter({
                   stringify: option => `${option.label} ${option.value} ${option.data.description}`
                })}
                options={options}
                value={defaultOptions}
                closeMenuOnSelect={false}
                components={animatedComponents}
                placeholder={this.props.selectorText ?? "Select conditions for this pattern."}
                onChange={(val) => {
                    patternConditionsUpdate(val);
                    updatePage(0);
                    closePatternDetails(null);
                }}
            />
        );
    }
}

export default PatternConditionInput;